// extracted by mini-css-extract-plugin
module.exports = {"paragraphSmall":"DefaultParagraph-module--paragraph-small--105aR","paragraphXsmall":"DefaultParagraph-module--paragraph-xsmall--3j8eT"};